import {defineStore} from "pinia";
import api from "@/authSection/api/api";

export type RootState = {
    isAuth: boolean | null,
};

export const useClientStore = defineStore({
    id: "clientStore",
    state: () => {
        return {
            isAuth: null,
        } as RootState
    },

    actions: {
        async setAuthStatus() {
            this.isAuth = await api.getAuthStatus()
        },
    },
})